import { IconButton } from "@mui/material";
import { SnackbarKey, useSnackbar } from "notistack";
import * as React from "react";
import { MdClose } from "react-icons/md";

type Props = {
  snackbarKey: SnackbarKey;
};
const SnackbarCloseButton: React.FC<Props> = (props) => {
  const { closeSnackbar } = useSnackbar();
  const onClickSnackbar = () => closeSnackbar(props.snackbarKey);
  return (
    <IconButton onClick={onClickSnackbar} color={"inherit"} size={"small"}>
      <MdClose color="inherit" />
    </IconButton>
  );
};

export default SnackbarCloseButton;
